var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtRetirementLarge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 116,
    viewBox: "0 0 134 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.207 3.98h-.439l-.481 3.913C1.418 7.553 0 5.933 0 3.98 0 1.782 1.795 0 4.009 0h.662a4.048 4.048 0 0 1 2.064.573h.006a3.973 3.973 0 0 1 1.92 3.016c.01.124.02.25.02.377v.014c0 .186-.018.368-.043.548a3.893 3.893 0 0 1-.66 1.698c-.04.056-.082.11-.121.163-.032.04-.06.084-.094.124a3.946 3.946 0 0 1-.977.843 3.994 3.994 0 0 1-2.117.604h-.663c-.099 0-.195-.008-.291-.014L4.2 3.98h.006z",
    id: "ol7juk1z4a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 67,
    cy: 112.439,
    rx: 67,
    ry: 3.561
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5B045",
    d: "m23.238 71.541-21.48-1.574L36.882 8.682zM99.68 24.412 107.783 4.6 36.882 8.682zM36.882 8.682 76.7 44.217 51.307 59.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7DD",
    d: "m36.882 8.682 62.798 15.73L76.7 44.217zM36.882 8.682 23.238 71.541l28.069-11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.545.148a.994.994 0 0 1 1.365.318l69.627 111.323h-2.333L31.225 1.503a.98.98 0 0 1 .32-1.355z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.378 31.858C30.277 44.866 13.09 58.923 3.649 70.105l-1.89-.138L9.54 59.859 34.25 31.267l24.19-14.911 36.768-9.31 12.576-2.445-.713 1.743c-14.284 3.443-34.592 12.502-55.692 25.51v.004z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m1.758 69.967 7.783-10.108 27.34-51.177zM107.783 4.6 95.21 7.047 36.882 8.682zM36.882 8.682l21.556 7.674-24.186 14.911z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M36.882 8.682 95.21 7.046l-36.772 9.31zM36.882 8.682 9.542 59.86l24.71-28.592z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.721 60.997)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m12.987 45.878 5.182-30.482 2.01.336-5.182 30.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m19.177 19.75-1.326-.934.65-3.68.741.122.647.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m3.939 47.335 70.98-24.087 1.19 3.458L5.13 50.792z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 7.953,
    cy: 47.88,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m43.184 37.876-3.607-2.636 4.239-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 3.12 2.183.18l65.19 47.664-2.183 2.942z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 64.647,
    cy: 48.091,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 65.922,
    cy: 48.091,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "m14.261 45.879 5.182-30.483 2.01.337-5.182 30.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M20.453 19.75h-1.325l.648-4.613.742.12.648.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#522D0E",
    d: "m6.404 50.792 70.981-24.089-1.19-3.457L5.213 47.332l-.082 3.46z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 9.227,
    cy: 47.88,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M44.458 37.876h-1.274l-2.333-2.636 4.239-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m1.274 3.123 65.191 47.67 2.18-2.944-16.978-12.418h-1.275l.572-.512L3.457.18H2.183z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "m12.987 45.878 5.182-30.482 2.01.336-5.182 30.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m19.177 19.75-1.326-.934.65-3.68.741.122.647.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784114",
    d: "m3.939 47.335 70.98-24.087 1.19 3.458L5.13 50.792z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 7.953,
    cy: 47.88,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "m43.184 37.876-3.607-2.636 4.239-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#824716",
    d: "M0 3.12 2.183.18l65.19 47.664-2.183 2.942z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 64.647,
    cy: 48.091,
    rx: 1.079,
    ry: 1.071
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M76.196 23.246h-1.274l1.189 3.457h1.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M68.645 47.85h-1.274l-2.18 2.942h1.274z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5E3411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.85 25.683c0 .877.716 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.711-1.6 1.588zM1.855 3.427c0 .877.716 1.588 1.6 1.588.883 0 1.599-.711 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M93.55 85.095h4.939v3.173H93.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M98.489 85.095h4.935v3.173h-4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M103.424 85.095h4.938v3.173h-4.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M108.36 85.095h4.936v3.173h-4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M113.296 85.095h4.938v3.173h-4.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.571 86.68c0 .877.716 1.588 1.6 1.588.883 0 1.6-.71 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.711-1.6 1.588z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.149 101.533c6.378 0 13.04-1.957 19.6-5.8 6.78-3.97 11.008-8.474 11.183-8.662h-4.937c-.043.045-4.672 3.64-9.873 6.951-5.917 3.764-12.53 7.77-22.672 5.321-15.229-3.677-32.488-34.936-32.66-35.25h-4.938c5.546 11.653 16.812 32.56 37.261 36.616 2.31.458 4.64.826 7.03.826l.006-.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M118.233 85.095h4.935v3.173h-4.935zM48.238 62.839h4.935v3.173h-4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M43.3 62.839h4.938v3.173H43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.366 62.839H43.3v3.173h-4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M33.428 62.839h4.938v3.173h-4.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.493 62.839h4.935v3.173h-4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M23.556 62.839h4.938v3.173h-4.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.576 64.424c0 .877.716 1.588 1.6 1.588.883 0 1.599-.711 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.638 64.424c0 .877.716 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.71-1.6 1.588zM116.634 86.68c0 .877.716 1.588 1.6 1.588.882 0 1.599-.71 1.599-1.588 0-.877-.717-1.588-1.6-1.588-.883 0-1.6.711-1.6 1.588z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.211 101.533c6.379 0 13.04-1.957 19.6-5.8 6.781-3.97 11.008-8.474 11.184-8.662h-4.935c-.043.045-3.168 2.957-8.613 6.574-5.84 3.882-13.793 8.143-23.932 5.695-15.228-3.676-32.487-34.936-32.66-35.25H43.92c.716 1.31 17.432 32.442 33.267 36.268 2.29.553 8.632 1.175 11.021 1.175h.003z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.703 64.424c0 .877.717 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588zM111.699 86.68c0 .877.716 1.588 1.6 1.588.883 0 1.599-.71 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.711-1.6 1.588z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.276 101.533c6.38 0 13.04-1.957 19.6-5.8 6.781-3.97 11.008-8.474 11.184-8.662h-4.938c-.042.045-2.868 3.086-9.478 6.951-6.056 3.539-12.925 7.77-23.063 5.321-15.23-3.677-32.488-34.936-32.66-35.25h-4.938c.566 2.09 17.046 32.543 32.884 36.369 2.29.553 9.017 1.076 11.407 1.076l.002-.005z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.766 64.424c0 .877.716 1.588 1.6 1.588.883 0 1.599-.711 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588zM106.761 86.68c0 .877.716 1.588 1.6 1.588.883 0 1.6-.71 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.711-1.6 1.588z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.339 101.533c6.379 0 13.04-1.957 19.6-5.8 6.78-3.97 11.008-8.474 11.183-8.662h-4.934c-.043.045-2.427 2.499-9.038 6.364-6.055 3.541-13.366 8.353-23.504 5.905-15.229-3.676-32.488-34.936-32.66-35.25H34.05c.716 1.31 16.916 32.243 32.754 36.068 2.29.554 9.147 1.377 11.537 1.377l-.003-.002z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.831 64.424c0 .877.716 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.71-1.6 1.588zM101.826 86.68c0 .877.717 1.588 1.6 1.588.883 0 1.6-.71 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.883 0-1.6.711-1.6 1.588z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.404 101.533c6.379 0 13.04-1.957 19.6-5.8 6.781-3.97 11.008-8.474 11.184-8.662H99.25c-.042.045-3.378 3.06-9.988 6.926-6.056 3.541-12.415 7.791-22.556 5.343-15.23-3.676-32.488-34.936-32.661-35.25h-4.938c.717 1.31 16.993 32.83 32.83 36.653 2.291.554 9.072.79 11.461.79h.006z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.893 64.424c0 .877.717 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588zM96.889 86.68c0 .877.716 1.588 1.6 1.588.883 0 1.6-.71 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.711-1.6 1.588z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.467 101.533c6.378 0 13.04-1.957 19.6-5.8 6.78-3.97 11.007-8.474 11.183-8.662h-4.935c-.042.045-3.349 3.111-8.827 6.622-5.903 3.784-13.579 8.098-23.717 5.647-15.23-3.676-32.488-34.936-32.66-35.25h-4.936c.717 1.31 16.693 32.057 32.528 35.88 2.29.554 9.374 1.563 11.76 1.563h.004z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.532 101.533c6.378 0 13.04-1.957 19.6-5.8 6.78-3.97 11.008-8.474 11.183-8.662l-1.039-.953c-.042.045-4.286 4.562-10.897 8.427-6.056 3.542-15.402 7.246-25.54 4.798-15.23-3.677-32.488-34.936-32.66-35.25l-1.244.671c.717 1.31 17.732 32.122 33.57 35.945 2.29.554 4.64.826 7.03.826l-.003-.002z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.772 64.644c0 .543-.102 1.049-.275 1.466H24.365v-2.023h30.37c.023.176.037.362.037.552v.005z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.494 100.299c3.729-.61 10.405-3.632 10.405-3.632l.082-.346c.164.11.326.217.49.32 1.803-.932 3.47-1.958 5.02-2.95 3.957-2.539 6.783-4.844 8.063-5.943V86.68h31.216c0 .877-.716 1.588-1.6 1.588h-.44c-1.728 1.636-5.224 4.68-9.978 7.466-6.56 3.842-13.222 5.799-19.6 5.799a25.52 25.52 0 0 1-2.322-.113c-.875.073-1.747.113-2.616.113-.594 0-1.433-.04-2.39-.104-.852.067-1.701.104-2.545.104-.606 0-1.492-.034-2.514-.093a31.89 31.89 0 0 1-2.42.093c-.55 0-1.34-.045-2.254-.118-.9.075-1.795.118-2.684.118-.702 0-1.784-.02-3.02-.065-.64.04-1.28.065-1.918.065-1.367 0-4.266-.332-6.928-.717 1.903-.011 5.38-.099 7.956-.517h-.003z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.168 88.704H93.55V86.68h31.217c0 1.118-.717 2.024-1.6 2.024z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.532 101.533c6.378 0 13.04-1.957 19.6-5.8 6.78-3.97 11.008-8.474 11.183-8.662l-1.039-.953c-.042.045-4.286 4.562-10.897 8.427-6.056 3.542-15.402 7.246-25.54 4.798-15.23-3.677-32.488-34.936-32.66-35.25l-1.244.671c.717 1.31 17.732 32.122 33.57 35.945 2.29.554 4.64.826 7.03.826l-.003-.002z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.959 64.424c0 .877.716 1.588 1.6 1.588.883 0 1.599-.711 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588zM91.954 86.68c0 .877.716 1.588 1.6 1.588.883 0 1.6-.71 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.884 0-1.6.711-1.6 1.588z",
    fill: "#D61A1A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.832 60.996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.122 25.684c0 .877.716 1.588 1.6 1.588.883 0 1.599-.71 1.599-1.588 0-.877-.716-1.588-1.6-1.588-.883 0-1.6.711-1.6 1.588zM3.126 3.428c0 .877.717 1.588 1.6 1.588.883 0 1.6-.711 1.6-1.588 0-.877-.717-1.588-1.6-1.588-.883 0-1.6.71-1.6 1.588z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B1B",
    d: "M2.835 2.456h2.038V4.48H2.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m12.985 45.879 5.182-30.483 2.01.337-5.182 30.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m19.175 19.75-1.326-.933.65-3.68.74.122.648.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m3.935 47.335 70.98-24.086 1.191 3.458-70.98 24.086z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 7.951,
    cy: 47.881,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m43.182 37.878-3.607-2.637 4.238-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 3.12 2.183.18l65.19 47.664-2.183 2.942z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 64.645,
    cy: 48.092,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 65.919,
    cy: 48.092,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "m14.26 45.88 5.181-30.483 2.01.337-5.182 30.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M20.451 19.75h-1.326l.648-4.612.743.12.648.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m6.4 50.793 70.983-24.089-1.19-3.457L5.21 47.333l-.085 3.46z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 9.225,
    cy: 47.881,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M44.456 37.878h-1.274l-2.333-2.637 4.238-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m1.272 3.124 65.19 47.67 2.18-2.944-16.978-12.418H50.39l.572-.511L3.455.18H2.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m12.985 45.879 5.182-30.483 2.01.337-5.182 30.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m19.175 19.75-1.326-.933.65-3.68.74.122.648.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m3.935 47.335 70.98-24.086 1.191 3.458-70.98 24.086z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 7.951,
    cy: 47.881,
    rx: 1.079,
    ry: 1.071
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m43.182 37.878-3.607-2.637 4.238-1.44 3.607 2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 3.12 2.183.18l65.19 47.664-2.183 2.942z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E3411",
    cx: 64.645,
    cy: 48.092,
    rx: 1.079,
    ry: 1.071
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M76.194 23.247H74.92l1.189 3.457h1.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M68.643 47.85h-1.274l-2.18 2.943h1.274z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.76 97.005 9.527-12.649 2.703 2.007-9.528 12.649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.69 85.658 1.221-1.62 2.703 2.006-1.22 1.62z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.584 96.27a1.007 1.007 0 0 0 .206 1.415c.45.335 1.09.242 1.428-.205a1.007 1.007 0 0 0-.206-1.416 1.02 1.02 0 0 0-1.424.205h-.004z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m27.075 97.004 9.527-12.648 2.703 2.006-9.527 12.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m36.004 85.66 1.22-1.621 2.703 2.007-1.22 1.62zM28.897 96.27a1.006 1.006 0 0 0 .206 1.415c.45.335 1.092.242 1.426-.205a1.006 1.006 0 0 0-.206-1.416 1.028 1.028 0 0 0-1.43.205h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M18.196 111.834h22.536l1.773-13.866H16.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M32.145 97.968h5.359v3.466h-5.36zM21.427 97.968h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M41.74 104.9h-1.557v-3.466h2.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A66B29",
    d: "M16.053 95.635h26.825v2.333H16.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332318",
    d: "M16.424 95.264h26.08v2.024h-26.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD934E",
    d: "M16.053 94.221h26.825v2.024H16.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M18.745 101.434h5.359v3.466h-5.36zM29.464 101.434h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M32.145 104.9h5.359v3.466h-5.36zM21.427 104.9h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "m42.221 108.369-.911 3.465h-1.127v-3.465zM18.745 108.368h5.359v3.466h-5.36zM29.464 108.368h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AD6F2B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.505 101.434v-3.466h5l-.442 3.466zM16.865 101.434l-.441-3.466h5.002v3.466zM26.786 97.968h5.359v3.466h-5.36zM34.824 101.434h5.359v3.466h-5.36zM16.865 101.434h2.039v3.466h-1.557zM24.105 101.434h5.359v3.466h-5.36zM41.177 108.369h-3.672V104.9h4.113zM17.31 104.9h4.116v3.469h-3.672zM26.786 104.9h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.824 108.368h5.359v3.466h-5.36zM19.793 108.369v3.465h-1.13l-.909-3.465zM24.105 108.368h5.359v3.466h-5.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M42.38 98.95H30.56l-.782 1.042-1.398-1.041H16.548l-.124-.983h26.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    d: "M37.349 88.954h-4.213l1.58-2.097h4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M9.445 111.834H31.98l1.772-13.866H7.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M28.754 101.434v-3.466h5l-.442 3.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M23.395 97.968h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "m8.114 101.434-.441-3.466h5.002v3.466zM18.035 97.968h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M12.676 97.968h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M32.988 104.9h-1.556v-3.466h2.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M7.299 95.635h26.825v2.333H7.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M7.673 95.264h26.08v2.024H7.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1A356",
    d: "M7.299 94.221h26.825v2.024H7.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M26.073 101.434h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M9.994 101.434h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M8.114 101.434h2.039v3.466H8.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M20.713 101.434h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M15.354 101.434h5.359v3.466h-5.36zM32.426 108.369h-3.672V104.9h4.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M23.394 104.9h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M8.559 104.9h4.116v3.469H9.003zM18.035 104.9h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M12.675 104.9h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "m33.47 108.369-.912 3.465h-1.126v-3.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M26.073 108.368h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M9.994 108.368h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M11.042 108.369v3.465h-1.13l-.909-3.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M20.713 108.368h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M21.426 94.222h4.216l-2.823 3.746h-4.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M15.354 108.368h5.359v3.466h-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M33.629 98.95h-11.82l-.782 1.042-1.398-1.041H7.797l-.124-.983h26.08z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.323 97.003 9.528-12.649 2.702 2.007-9.527 12.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.252 85.666 1.221-1.62 2.703 2.006-1.221 1.621z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.145 96.27a1.007 1.007 0 0 0 .206 1.415c.45.335 1.09.242 1.427-.205a1.007 1.007 0 0 0-.206-1.416 1.025 1.025 0 0 0-1.427.205z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m17.637 96.999 9.527-12.649 2.703 2.007-9.528 12.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m26.567 85.657 1.221-1.62 2.703 2.006-1.221 1.621z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.46 96.27a1.006 1.006 0 0 0 .207 1.415c.45.335 1.092.242 1.426-.205a1.006 1.006 0 0 0-.206-1.416 1.023 1.023 0 0 0-1.427.205z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M39.237 88.38H29.113l.756-2.023h10.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D19040",
    d: "M37.29 84.35H27.165l2.704 2.024h10.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M29.801 87.358h-.688l-8.77 11.648h.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.315 90.764h5.376c1.156 0 2.098.933 2.098 2.083 0 .138-.113.25-.252.25h-.144v-.047a.25.25 0 0 1-.108-.206 1.59 1.59 0 0 0-1.594-1.582h-5.376a.252.252 0 0 1-.252-.25c0-.138.113-.25.252-.25v.002z",
    fill: "#7A8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.162 92.808h.363c0-.893.461-1.622 1.03-1.622.57 0 1.03.726 1.03 1.622h.363c0-1.116-.626-2.024-1.393-2.024s-1.393.908-1.393 2.024zM37.18 90.764h5.376c1.155 0 2.097.933 2.097 2.083a.252.252 0 0 1-.503 0 1.59 1.59 0 0 0-1.594-1.582h-5.377a.252.252 0 0 1-.252-.25c0-.138.113-.25.252-.25z",
    fill: "#A3BFD6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0E0E1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.184 91.439c0 1.537 1.294 2.783 2.89 2.783 1.597 0 2.891-1.246 2.891-2.783 0-1.538-1.294-1.802-2.89-1.802-1.597 0-2.891.262-2.891 1.802zM27.151 91.439c0 1.537 1.294 2.783 2.89 2.783 1.597 0 2.891-1.246 2.891-2.783 0-1.538-1.294-1.802-2.89-1.802-1.597 0-2.89.262-2.89 1.802z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#191A2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.94 91.439c0 1.537 1.294 2.783 2.89 2.783 1.598 0 2.892-1.246 2.892-2.783 0-1.538-1.294-1.802-2.891-1.802s-2.89.262-2.89 1.802zM26.908 91.439c0 1.537 1.293 2.783 2.89 2.783 1.597 0 2.89-1.246 2.89-2.783 0-1.538-1.293-1.802-2.89-1.802-1.597 0-2.89.262-2.89 1.802z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.475 92.558c-.447.98-1.464 1.666-2.647 1.666-1.401 0-2.57-.96-2.834-2.24 1.996.09 3.853.29 5.481.574zM31.607 91.93c.349 0 .691.004 1.034.012-.247 1.299-1.424 2.282-2.843 2.282-1.418 0-2.48-.888-2.8-2.09a51.968 51.968 0 0 1 4.61-.203z",
    fill: "#0E0E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.397 89.807.71.976a.585.585 0 0 1-.07.76.45.45 0 0 1-.683-.078L37.03 89.64c.504.01.971.054 1.37.167h-.002z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.41 90.216 2.11 2.586a.48.48 0 0 1-.377.784.49.49 0 0 1-.377-.177l-1.812-2.223c.046-.427.207-.742.46-.97h-.004z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.22 90.548a.67.67 0 0 1 .936.098l1.996 2.448a2.912 2.912 0 0 1-1.033.838l-1.999-2.45a.658.658 0 0 1 .1-.931v-.003z",
    fill: "#7A90A1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.798 89.64c.43 0 .838.021 1.203.086l.81 1.084a.554.554 0 0 1-.07.737.458.458 0 0 1-.683-.08l-1.367-1.824h.104l.003-.003z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.908 91.439c0-.453.113-.796.311-1.051l2.007 2.462a.48.48 0 0 1-.376.784.484.484 0 0 1-.377-.18l-1.563-1.917v-.1l-.002.002z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.93 90.598a.67.67 0 0 1 .936.099l2.104 2.58c-.3.33-.677.588-1.104.75l-2.036-2.495a.658.658 0 0 1 .1-.93v-.004z",
    fill: "#7A90A1",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.627 76.912)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C86BD",
    fillRule: "nonzero",
    d: "M2.773 16.202h5.603v2.024H2.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5597D4",
    fillRule: "nonzero",
    d: "M2.773 16.202h5.603l1.2-9.776H1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "m9.14 6.426-1.149 9.343H3.155L2.01 6.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "m9.14 6.426-1.149 9.343H3.155L2.01 6.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A016",
    fillRule: "nonzero",
    d: "m8.954 7.938-.963 7.83H3.155l-.962-7.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79216",
    fillRule: "nonzero",
    d: "M6.3 7.938h2.654l-.963 7.83h-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37F05",
    fillRule: "nonzero",
    d: "M8.013 7.938h1.445l-1.28 7.83H7.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    d: "M3.119 7.938h2.038v7.83H3.882zM7.272 9.717c0 .556.453 1.012 1.02 1.012a1.011 1.011 0 1 0 0-2.024c-.567 0-1.02.45-1.02 1.012zm.181.18c0-.558.458-1.012 1.02-1.012.56 0 1.019.454 1.019 1.012s-.458 1.012-1.02 1.012c-.561 0-1.019-.454-1.019-1.012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.115 11.128c0 .556.453 1.012 1.019 1.012a1.011 1.011 0 1 0 0-2.024c-.566 0-1.02.45-1.02 1.012zm.18.18c0-.557.458-1.012 1.02-1.012s1.02.455 1.02 1.012c0 .558-.458 1.012-1.02 1.012s-1.02-.454-1.02-1.012z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.713 14.566c0 .556.453 1.012 1.02 1.012a1.011 1.011 0 1 0 0-2.024c-.567 0-1.02.45-1.02 1.012zm.181.18c0-.558.458-1.012 1.02-1.012.561 0 1.019.454 1.019 1.012 0 .557-.458 1.012-1.02 1.012-.561 0-1.019-.455-1.019-1.012zM2.722 9.394c0 .558.457 1.012 1.02 1.012.562 0 1.019-.454 1.019-1.012s-.457-1.012-1.02-1.012c-.562 0-1.019.454-1.019 1.012zm.26.259a1.019 1.019 0 0 1 2.04 0 1.019 1.019 0 0 1-2.04 0z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.522 12.818c0 .558.457 1.011 1.019 1.011.562 0 1.02-.453 1.02-1.011 0-.559-.458-1.012-1.02-1.012s-1.02.453-1.02 1.012zm.26.258c0-.564.459-1.012 1.02-1.012.56 0 1.019.456 1.019 1.012a1.019 1.019 0 0 1-2.039 0zM7.086 10.929c0 .485.387.87.877.87.489 0 .876-.385.876-.87a.88.88 0 0 0-.876-.87.88.88 0 0 0-.877.87z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.963 9.152c0 .562.456 1.012 1.026 1.012.57 0 1.013-.45 1.013-1.012S8.546 8.14 7.989 8.14c-.557 0-1.026.45-1.026 1.012zM7.847 14.487a1.019 1.019 0 0 0 2.038 0 1.019 1.019 0 0 0-2.038 0z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    cx: 6.587,
    cy: 14.768,
    rx: 1.019,
    ry: 1.012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.577 16.202c0 .553.461 1.012 1.019 1.012.558 0 1.019-.459 1.019-1.012 0-.554-.461-1.012-1.02-1.012-.557 0-1.018.458-1.018 1.012zM2.857 9.228a.75.75 0 0 0 .754.749.75.75 0 0 0 .754-.749.763.763 0 0 0-.754-.749.75.75 0 0 0-.754.75zM4.885 9.605c0 .557.458 1.012 1.02 1.012.56 0 1.019-.455 1.019-1.012 0-.558-.458-1.012-1.02-1.012-.56 0-1.019.454-1.019 1.012z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.965 11.786c0 .552.45 1.012 1.02 1.012.568 0 1.019-.447 1.019-1.012 0-.552-.45-1.012-1.02-1.012-.569 0-1.019.447-1.019 1.012z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.208 13.32c0 .507.408.911.917.911a.91.91 0 1 0 0-1.821.91.91 0 0 0-.917.91z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.594 10.861c-1.897-.368-3.332-2.026-3.332-4.02 0-.14.008-.28.022-.415H9.14l-.546 4.435z",
    fill: "#A15A0E",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.263 13.666c0 .56.455 1.012 1.02 1.012.563 0 1.018-.451 1.018-1.012 0-.56-.455-1.012-1.019-1.012-.564 0-1.02.452-1.02 1.012z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.757 13.512h1.235c.274 0 .498.222.498.495v1.225a.497.497 0 0 1-.498.495H5.757a.497.497 0 0 1-.498-.495v-1.225c0-.273.224-.495.498-.495z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.215 14.553v.982l-2.039-1.322.203-.701h.224l1.607 1.041h.005z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "M8.067 16.005 6.03 14.872l.304-.89 1.734.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.072 13.512h1.234c.275 0 .499.222.499.495v1.225a.497.497 0 0 1-.499.495H5.072a.497.497 0 0 1-.498-.495v-1.225c0-.273.223-.495.498-.495z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.443 15.76h.59c.286 0 .514-.139.514-.307v-1.407c0-.171-.233-.307-.514-.307H5.865c-.2 0-.357.094-.357.214 0 .119.157.213.357.213h.973v1.171h-.39c-.194 0-.356.094-.356.213 0 .12.162.213.357.213l-.006-.003z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.385 15.76c.329 0 .587-.23.587-.523v-.453h.285c.33 0 .587-.23.587-.524 0-.293-.258-.523-.587-.523h-.605c-.472 0-.846.34-.846.754v.746c0 .285.267.523.587.523h-.008z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#779CBF",
    fillRule: "nonzero",
    d: "M3.103 8.45H4.95V6.425H2.912z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.768 12.385.453-1.14a.5.5 0 0 1 .646-.279l1.149.45c.255.1.381.389.28.642l-.453 1.14a.5.5 0 0 1-.647.279l-1.148-.45a.494.494 0 0 1-.28-.642z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.186 12.556a.428.428 0 0 1-.025.073l-.243.57-1.77-1.646.406-.377.233.087 1.394 1.297.005-.004z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "m8.466 13.613-1.704-1.506.588-.518 1.45 1.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.129 12.15.453-1.139a.5.5 0 0 1 .647-.278l1.148.45c.255.1.381.388.28.642l-.453 1.14a.5.5 0 0 1-.647.278l-1.148-.45a.494.494 0 0 1-.28-.642z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.437 13.03.476.12c.23.058.49-.014.579-.161l.753-1.22c.09-.147-.024-.312-.254-.372l-.947-.237c-.16-.039-.338.009-.4.111-.06.102.014.216.174.258l.787.198-.626 1.015-.316-.08c-.16-.04-.339.008-.405.11-.06.102.014.217.174.259h.005z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.005 12.904c.259.111.548-.025.647-.316l.16-.452.22.102c.259.111.548-.026.654-.316.1-.29-.022-.615-.281-.734l-.487-.214c-.373-.162-.79.043-.935.461l-.267.743c-.098.29.023.615.282.735l.007-.009z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF6",
    d: "M0 .774 1.92.096l5.426 15.167-1.921.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD7DE",
    d: "m.017.863 1.92-.677 5.426 15.167-1.921.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C93E47",
    d: "m.633.691 1.92-.678L7.99 15.176l-1.92.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB2E36",
    d: "M.169.858 2.09.18l5.42 15.17-1.922.676z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.763 12.241 1.042-.657a.501.501 0 0 1 .688.152l.662 1.035a.493.493 0 0 1-.154.683l-1.042.657a.501.501 0 0 1-.687-.153l-.662-1.034a.493.493 0 0 1 .153-.683z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.956 11.69s.028.09.04.14l.28 1.11-1.968.774-.071-1.14.17-.269 1.553-.615h-.004z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "m6.48 13.514-1.935.67-.104-1.461 1.644-.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.19 12.601 1.042-.657a.501.501 0 0 1 .688.151l.662 1.034a.493.493 0 0 1-.153.683l-1.041.658a.501.501 0 0 1-.688-.152l-.663-1.034a.493.493 0 0 1 .153-.683z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.326 14.082.316-.192a.31.31 0 0 0 .1-.436l-.804-1.216a.335.335 0 0 0-.45-.096l-.629.383a.21.21 0 0 0-.069.3.23.23 0 0 0 .313.067l.522-.317.67 1.01-.21.13a.21.21 0 0 0-.068.3.23.23 0 0 0 .312.067h-.003z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76 14.612c.311-.14.402-.422.2-.64l-.311-.343.271-.12c.312-.14.403-.42.212-.638-.202-.218-.604-.281-.916-.14l-.583.259c-.443.197-.573.61-.292.92l.503.554c.201.218.604.28.915.14v.008z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6583A1",
    fillRule: "nonzero",
    d: "M9.602 8.45H7.86l.135-2.024H9.9z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.37 2.446)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ebncotlrfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ol7juk1z4a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ebncotlrfb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.04 -1.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.782 5.05c0-1.934 1.418-3.533 3.278-3.84v-.059h.649c2.168 0 3.927 1.746 3.927 3.9 0 2.152-1.759 3.898-3.927 3.898H5.06v-.06C3.2 8.584 1.782 6.982 1.782 5.05z",
    fill: "#FF9500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.944 5.672c0-.448.347-.819.857-1.004.081.664.122 1.344.142 2.024-.57-.155-.978-.541-.978-1.035l-.02.015z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24 5.255a.72.72 0 0 1 .713-.708.72.72 0 0 1 .713.708.72.72 0 0 1-.713.709.72.72 0 0 1-.714-.709z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.293 4.68a.72.72 0 0 0 .713.707.72.72 0 0 0 .714-.708.707.707 0 0 0-.714-.708.72.72 0 0 0-.713.708z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.754 3.898c0 .465.387.85.836.85.448 0 .856-.385.856-.85a.858.858 0 0 0-.856-.85.84.84 0 0 0-.836.85z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.595 3.203a.45.45 0 0 0 .449.446.45.45 0 0 0 .448-.446.45.45 0 0 0-.448-.445.45.45 0 0 0-.449.445z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.518 3.317a.91.91 0 0 1-.917-.91c0-.223.081-.426.224-.588.53.263 1.04.567 1.55.87a.907.907 0 0 1-.857.608v.02z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.813 2.461c0 .547.448 1.012 1.02 1.012.57 0 1.018-.445 1.018-1.012 0-.566-.448-1.012-1.019-1.012-.57 0-1.02.446-1.02 1.012z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.017 1.973a.633.633 0 0 1-1.264 0c0-.101.02-.182.061-.263.408.08.795.162 1.203.263z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.577 3.13c0 .559.457 1.012 1.02 1.012.562 0 1.019-.453 1.019-1.012 0-.558-.457-1.012-1.02-1.012-.562 0-1.019.454-1.019 1.012zM8.69 6.253c0 .565.461 1.012 1.02 1.012.557 0 1.018-.458 1.018-1.012s-.461-1.012-1.019-1.012c-.558 0-1.02.458-1.02 1.012z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.962 7.046c0 .55.447 1.012 1.019 1.012.572 0 1.02-.444 1.02-1.012 0-.568-.448-1.012-1.02-1.012-.572 0-1.02.444-1.02 1.012z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.956 7.625c0 .506.408.91.917.91a.91.91 0 1 0 0-1.82.91.91 0 0 0-.917.91z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.042 7.229c.224 0 .407.056.59.15a27.022 27.022 0 0 1-1.508 1.873 1.146 1.146 0 0 1-.367-.832c0-.662.571-1.191 1.285-1.191z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FA8C16",
    fillRule: "nonzero",
    cx: 9.389,
    cy: 8.271,
    rx: 1.019,
    ry: 1.012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.442 8.65c0 .365.306.669.673.669a.676.676 0 0 0 .672-.668.676.676 0 0 0-.672-.668.676.676 0 0 0-.673.668z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.512 8.699c0 .557.458 1.011 1.02 1.011.56 0 1.019-.454 1.019-1.011 0-.558-.458-1.012-1.02-1.012-.561 0-1.019.454-1.019 1.012z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.545 8.336c.484 0 .888.344.989.81-.545.344-1.09.688-1.676.991a1.002 1.002 0 0 1-.363-.769c0-.566.464-1.032 1.03-1.032h.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.315 9.39c0 .364.306.668.673.668a.676.676 0 0 0 .672-.668.676.676 0 0 0-.672-.668.676.676 0 0 0-.673.668z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.506 9.53c0 .527.429.932.938.932.51 0 .938-.425.938-.931a.932.932 0 0 0-.938-.931.945.945 0 0 0-.938.93zM10.918 5.587a16.423 16.423 0 0 1-.428 2.024c-.367-.208-.611-.536-.611-.934 0-.536.448-.969 1.04-1.09z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.698 6.028a.59.59 0 0 0 .592.587.59.59 0 0 0 .59-.587.59.59 0 0 0-.59-.587.59.59 0 0 0-.592.587zM9.465 3.743c0-.203.06-.385.142-.547.347.567.653 1.134.958 1.72-.611-.06-1.1-.546-1.1-1.173z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E07E14",
    cx: 5.06,
    cy: 5.05,
    rx: 3.927,
    ry: 3.899
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9E16",
    transform: "rotate(-45 5.059 5.05)",
    cx: 5.059,
    cy: 5.051,
    r: 3.574
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 5.05c0 1.897 1.55 3.435 3.46 3.435 1.911 0 3.46-1.538 3.46-3.435S6.971 1.615 5.06 1.615c-1.91 0-3.46 1.538-3.46 3.435z",
    fill: "#F7E6B4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.084 4.648c.084 0 .16-.053.19-.13l.819-2.335a.191.191 0 0 0-.125-.244 2.809 2.809 0 0 0-1.768 0 .191.191 0 0 0-.125.244l.82 2.336c.026.079.105.13.19.13zM5.084 8.305c.3 0 .596-.048.884-.143a.191.191 0 0 0 .125-.245l-.82-2.336a.2.2 0 0 0-.189-.129.204.204 0 0 0-.189.13l-.82 2.335a.193.193 0 0 0 .122.245c.288.095.588.143.884.143h.003z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.346 4.766c.06.06.147.073.224.037l2.228-1.09a.19.19 0 0 0 .088-.257 2.58 2.58 0 0 0-.507-.705 2.66 2.66 0 0 0-.71-.503.19.19 0 0 0-.258.087L5.312 4.547a.192.192 0 0 0 .037.222l-.003-.003zM2.742 7.352c.203.205.444.374.71.503a.195.195 0 0 0 .26-.087l1.1-2.212a.194.194 0 0 0-.26-.259L2.32 6.388a.19.19 0 0 0-.087.256c.13.264.3.503.507.705v.003z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.462 5.082c0 .084.054.16.13.189l2.353.818a.193.193 0 0 0 .247-.125 2.782 2.782 0 0 0 0-1.764.193.193 0 0 0-.247-.125l-2.352.819a.197.197 0 0 0-.13.188zM1.782 5.082c0 .3.048.595.144.882.034.105.145.16.247.125l2.352-.818a.197.197 0 0 0 .13-.189.2.2 0 0 0-.13-.188l-2.352-.819a.195.195 0 0 0-.247.122 2.782 2.782 0 0 0-.144.882v.003z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.346 5.334a.191.191 0 0 0-.037.222l1.099 2.212a.192.192 0 0 0 .258.087c.266-.129.506-.298.71-.503.204-.205.377-.441.507-.705a.193.193 0 0 0-.088-.256L5.567 5.3a.195.195 0 0 0-.224.036l.003-.003zM2.742 2.748a2.642 2.642 0 0 0-.507.706.188.188 0 0 0 .088.255L4.55 4.8a.195.195 0 0 0 .223-.037.188.188 0 0 0 .037-.219L3.713 2.332a.192.192 0 0 0-.258-.087c-.266.13-.507.3-.71.503h-.003z"
  })))))), /*#__PURE__*/React.createElement("path", {
    fill: "#4578AB",
    fillRule: "nonzero",
    d: "M5.188 16.202h2.998v2.024H5.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4171A1",
    fillRule: "nonzero",
    d: "M6.833 16.202h2.038v2.024H6.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518FC9",
    fillRule: "nonzero",
    d: "M3.198 16.202h2.038v2.024H3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M7.991 15.769H3.155L2.01 6.426H9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78 10.347c.024-.298.393-.523.826-.506.43.02.757.275.729.573l-.478 5.358H6.298l.486-5.425H6.78zM4.466 6.426l.313 3.179c.03.298-.33.553-.804.573-.478.02-.88-.208-.911-.506l-.322-3.246h1.724z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M5.115 6.426H9.14l-1.149 9.343H5.115z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtRetirementLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-retirement-large.b87e06f3e82e2e3fe58a1fa0d1f49c43.svg";